import React from 'react'
import './Video.css'

const Video = (props) => {
    return (
        <div className='videoMStylesIndv'>
            <video
                playsInline
                src={props.video}
                autoPlay
                loop
                muted
            ></video>
        </div>
    )
}

export default Video
